// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Li-z","tupacHeader":"Mi-z","tupacHeader2":"Ni-z","tupacMenu":"Oi-z","tupacMenu2":"Pi-z","tupacMain":"Qi-z","tupacMain2":"Ri-z"};